import type { lazy } from '$lib/utils/types';

export function getRequestInfo(url: URL) {
    let referer = '';

    if (typeof window != 'undefined') {
        referer = window.document.referrer;
    }

    return JSON.stringify({
        domain: url.hostname,
        path_info: url.pathname,
        referer,
    });
}

export function getRequestInfoInput(url: URL) {
    let referer = '';

    if (typeof window != 'undefined') {
        referer = window.document.referrer;
    }

    return {
        domain: url.hostname,
        pathInfo: url.pathname,
        referer,
    } as const;
}

const splashscreenKey = 'goafrica-splashscreen-ad-showing-at-key';

export function mustShowingSplashscreen({
    url,
    browser,
}: {
    url: URL;
    browser: lazy<boolean>;
}) {
    if (!browser()) {
        return false;
    }

    const forcedCompanyId = url.searchParams.get('FORCE_COMPANY_AD');
    if (forcedCompanyId != null && forcedCompanyId !== '') {
        return true;
    }

    const disabled = url.searchParams.get('disabledSplashscreen') ?? '0';
    if (parseInt(disabled) === 1) {
        return false;
    }

    const value = window.localStorage.getItem(splashscreenKey);
    if (value == null) {
        return true;
    }
    const showingAt = parseFloat(value);
    const now = new Date().getTime() / 1000;

    const SECOND = 1;
    const MINUTE = 60 * SECOND;
    const HOUR = 60 * MINUTE;

    return now - showingAt > 12 * HOUR;
}

export function markSplashscreenAsShowed() {
    if (typeof window !== 'undefined') {
        window.localStorage.setItem(splashscreenKey, `${new Date().getTime() / 1000}`);
    }
}
